"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LocationImage_1 = __importDefault(require("@components/Images/LocationImage"));
var table_style = __importStar(require("./Table.module.scss"));
var button_style = __importStar(require("@components/Buttons/Button.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@assets/icons");
function TableWithImages(_a) {
    var data = _a.data, handleDeteleItem = _a.handleDeteleItem, handleDup = _a.handleDup, loc = _a.loc;
    var navigate = (0, react_router_dom_1.useNavigate)();
    console.log(data);
    return ((0, jsx_runtime_1.jsxs)("table", { className: table_style.table, children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: loc.nameHeader }), (0, jsx_runtime_1.jsx)("th", { children: loc.actionHeader })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: data.map(function (item) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { style: { height: "150px" }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                                    display: "grid",
                                    alignItems: "center",
                                    gridTemplateColumns: "200px 200px",
                                    gap: 20,
                                }, children: [item.img ? ((0, jsx_runtime_1.jsx)(LocationImage_1.default, { path: item.img, alt: "no img", width: "90px" })) : ((0, jsx_runtime_1.jsx)("span", { style: { fontSize: "1.7rem", color: "grey" }, children: icons_1.icons.close })), (0, jsx_runtime_1.jsx)("span", { children: item.name })] }) }), (0, jsx_runtime_1.jsxs)("td", { style: {
                                height: "150px",
                                display: "flex",
                                alignItems: "center",
                                width: "auto",
                                justifyContent: "center",
                                flexDirection: "row",
                                gap: 5,
                            }, children: [(0, jsx_runtime_1.jsx)("button", { className: button_style.create_btn, onClick: function () { return navigate("".concat(item.id)); }, children: icons_1.icons.edit }), (0, jsx_runtime_1.jsx)("button", { className: button_style.delete_btn, onClick: function () {
                                        handleDeteleItem(item);
                                    }, children: icons_1.icons.delete }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return handleDup(item); }, children: "Dup" })] })] }, item.id)); }) })] }));
}
exports.default = TableWithImages;
